import React, { useEffect } from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useIsAuthenticated,
} from "@azure/msal-react";
import "./estilos/App.css";
import Home from "./Home";
import Landing from "./paginas/Landing";
import { NavegacionContexto } from "./contextos/ContextoNavegacion.js";

/**
 * El sitio publico va incrustado en el HTML de index.html, dentro de
 * #sitio-publico, para que los rastreadores lo lean sin ejecutar JavaScript.
 * La aplicacion interna monta en #root sobre esa misma pagina.
 *
 * Este componente decide cual de los dos se ve:
 *
 *   - Visitante normal en la raiz      -> sitio publico, React no pinta nada
 *   - Alguien que entra por /acceso    -> pantalla de autenticacion
 *   - Sesion iniciada                  -> aplicacion de gestion
 *
 * La raiz sirve tanto el sitio publico como la aplicacion a proposito: es
 * la unica URI de retorno registrada en Azure AD, de modo que mover la
 * aplicacion a otra ruta obligaria a registrarla alli primero.
 */

const RUTA_ACCESO = "/acceso";

const esRespuestaDeAutenticacion = () => {
  const hash = window.location.hash || "";
  return (
    hash.indexOf("code=") !== -1 ||
    hash.indexOf("id_token=") !== -1 ||
    hash.indexOf("error=") !== -1
  );
};

const MainContent = () => {
  const autenticado = useIsAuthenticated();

  // Se contempla la respuesta de autenticacion para que el sitio publico no
  // asome un instante mientras MSAL procesa el retorno desde Azure AD.
  const mostrarAplicacion =
    autenticado ||
    window.location.pathname === RUTA_ACCESO ||
    esRespuestaDeAutenticacion();

  useEffect(() => {
    const publico = document.getElementById("sitio-publico");
    if (publico) {
      publico.style.display = mostrarAplicacion ? "none" : "";
    }
    document.body.classList.toggle("aplicacion-activa", mostrarAplicacion);
  }, [mostrarAplicacion]);

  if (!mostrarAplicacion) return null;

  return (
    <div className="App notranslate">
      <AuthenticatedTemplate>
        <NavegacionContexto>
          <Home />
        </NavegacionContexto>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Landing />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default function App() {
  return <MainContent />;
}
